
import { DialogLike } from '../types';

/**
 * This migration got introduced because we were using an internal type in the game for character position
 * which is different from schema. They have now been sycned up
 */

export const migrateRevertCharPos = async (story: DialogLike): Promise<DialogLike> => {

  story.steps = story.steps.map((step: any) => {
    step.gestures = step.gestures.map((gesture: any) => ({
      ...gesture,
      charPos: {
        x: gesture.charPos.from.x,
        y:  gesture.charPos.from.y,
      }
    }));

    return step;
  });
    

  return story;
};
